import { Expose } from 'class-transformer';

export class GenerationLimit {
  @Expose({ name: 'left_generations_number' })
  leftGenerationsNumber!: number;
}
